import React, { useState, useEffect, useCallback, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Preloader from "../../components/Preloader";
import Input from "../../components/Input";
import Select from "../../components/Select";
import { TypesService } from "../../services/TypesService";
import { LeadService } from "../../services/LeadService";
import { AuthContext } from "../../context/AuthContext";

const RegistrarLead = () => {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const { id, j } = useParams();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [disableVenta, setDisableVenta] = useState(true);
  const [phone, setPhone] = useState("");
  const [reportedSelected, setReportedSelected] = useState("");
  const [notes, setNotes] = useState("");
  const [statusSelected, setStatusSelected] = useState("");
  const [data, setData] = useState({});
  const [seguimiento, setSeguimiento] = useState([]);
  const [statusLead, setStatusLead] = useState([]);
  const onlyRead = j === "only";
  const [errors, setErrors] = useState({});

  const handleBackToList = () => {
    navigate("/admin/leads");
  };

  const getFollowing = useCallback(async () => {
    setLoading(true);
    try {
      const responseStatus = await TypesService.get({
        token: token,
        table: 'estado_leads'
      });
      const rStatusList = responseStatus
        .sort((a, b) => (a.Secuencia || 0) - (b.Secuencia || 0))
        .map((r) => ({
          id: r.id,
          nombre: r.descripcion
        }));

      setStatusLead(rStatusList);
      const responseLead = await LeadService.getById({
        token: token,
        vid: id
      });
      const leadData = responseLead.lead;
      if (leadData.codigo_venta_cliente || leadData.id_estado_lead !== 4) {
        setDisableVenta(true);
      } else {
        setDisableVenta(false);
      }
      if (!onlyRead && leadData.codigo_venta_cliente) {
        navigate("/admin/leads");
        return;
      }
      setData(responseLead.lead);
      setSeguimiento(responseLead.lead.seguimiento);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error al obtener la venta:", error);
    }
  }, [id, token, onlyRead, navigate]);

  useEffect(() => {
    if (id) {
      getFollowing();
    }
  }, [id, getFollowing]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const isValid = validateForm();
    if (!isValid) { setLoading(false); return; }
    try {
      const response = await LeadService.save({
        token: token,
        formData: {
          id_lead: id,
          reportedSelected: reportedSelected,
          notes: notes,
          statusSelected: statusSelected,
          phone: phone,
        }
      });
      if (response.success) {
        toast.success(response.message);
        navigate("/admin/leads");
        return;
       
      } else {
        setError(response.message);
      }

    } catch (err) {
      setError("Error al registrar el seguimiento.");
      console.log("Error al registrar el seguimiento", err);
    } finally {
      setLoading(false);
    }
  };

  const validateForm = () => {
    let newErrors = {};

    if (!statusSelected || statusSelected === "0") {
      newErrors.statusSelected = "El estado es obligatorio";
    }

    if (!reportedSelected || reportedSelected === "0") {
      newErrors.reportedSelected = "Debe seleccionar la contactabilidad";
    }

    if (!phone.trim()) {
      newErrors.phone = "El número de contacto es obligatorio";
    } else if (Number.isNaN(phone)) {
      newErrors.phone = "El número debe contener solo dígitos";
    } else if (phone.length < 7) {
      newErrors.phone = "Número demasiado corto";
    }

    if (!notes.trim()) {
      newErrors.notes = "La observación es obligatoria";
    } else if (notes.length < 10) {
      newErrors.notes = "La observación debe tener al menos 10 caracteres";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <div className="ventas-admin-content">
      {loading && <Preloader />}
      <div className="breadcrumb-container">
        <span className="breadcrumb-link" onClick={handleBackToList}>
          ← Listado de Leads
        </span>
        <span className="breadcrumb-current"> / Leads</span>
      </div>
      <div className="nuevo-producto-card">
        <div className="flex justify-between gap-20">
          <div className=" w-70">
            <span className="nueva-venta-instalada-title"> Registrar Seguimiento</span>
            <div className="dashboard-card nueva-venta-responsive">

              <form
                className="nueva-venta-form"
                onSubmit={handleSubmit}
                autoComplete="off"
              >

                {error && <div className="error-message">{error}</div>}

                <div className="form-grid-3">
                  <div className="">
                    <Select title="Estado" value={statusSelected} setValue={setStatusSelected} options={
                      [
                        ...[
                          {
                            id: 0,
                            nombre: 'Seleccione'
                          }
                        ],
                        ...statusLead
                      ]} disable={onlyRead} />

                    {errors.statusSelected && <span className="error">{errors.statusSelected}</span>}
                  </div>
                  <div className="">
                    <Select title="Contactabilidad" value={reportedSelected} setValue={setReportedSelected} options={[
                      {
                        id: 0,
                        nombre: 'Seleccione'
                      },
                      {
                        id: 1,
                        nombre: 'Contesta'
                      },
                      {
                        id: 2,
                        nombre: 'No contesta'
                      },
                    ]} disable={onlyRead} />
                    {errors.reportedSelected && <span className="error">{errors.reportedSelected}</span>}
                  </div>
                  <div className="">
                    <Input title="Num. contactado" value={phone} setValue={setPhone} placeholder="Ingrese numero" disable={onlyRead} />
                    {errors.phone && <span className="error">{errors.phone}</span>}
                  </div>
                </div>

                <div className="flex justify-between pt-10 items-end">
                  <div className="w-65">
                    <Input title="Observación" value={notes} setValue={setNotes} placeholder="" type="textarea" disable={onlyRead} />
                    {errors.notes && <span className="text-error">{errors.notes}</span>}
                  </div>
                  <div className="w-30">
                    <button
                      className="btn btn-primary w-full"
                      type="submit"
                      disabled={loading || onlyRead}
                    >
                      {loading
                        ? "Procesando..."
                        : "Registrar"
                      }
                    </button>
                  </div>
                </div>
              </form>
            </div>

            <div className="ventas-table-wrapper pt-40">
              <table className="ventas-table">
                <thead>
                  <tr>
                    <th>F. Gestión</th>
                    <th>Back</th>
                    <th>Estado</th>
                    <th>Num. Contactado</th>
                    <th>Observación</th>
                    <th># Contac</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    seguimiento.map((r, k) => (
                      <tr key={r.id}>
                        <td>{new Date(r.fecha).toLocaleDateString()}</td>
                        <td>{r.nombre_vendedor}</td>
                        <td>{r.estado}</td>
                        <td>{r.numero_contactado}</td>
                        <td>{r.observacion}</td>
                        <td>{k + 1}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>

          </div>
          <div className="container w-30 bl-1">
            {
              data?.id !== undefined && (
                <div className="container-gray">
                  <p>Tipo base - {data.tipo_base} </p>
                  <p>CODIGO DE VENTA</p>
                  <p>TIPO DOCUMENTO - DNI</p>
                  <p>NÚMERO DOCUMENTO - {data.numero_documento}</p>
                  <p>NOMBRES COMPLETOS / RAZÓN SOCIAL</p>
                  <p>{data.nombre} {data.apellido_paterno} {data.apellido_materno}</p>
                  <p>TELÉFONO: {data.telefono_1}</p>
                  <p>TELÉFONO: {data.telefono_2}</p>
                  <p>TELÉFONO: {data.telefono_3}</p>
                  <p>Estado - {data.estado}</p>
                  {seguimiento && seguimiento.length > 0 && (
                    <button
                      className="btn btn-orange"
                      type="button"
                      disabled={disableVenta || loading}
                      onClick={() => navigate(`/admin/ventas/registrar/?id_lead=${data.id}`)}
                    >
                      V E N T A
                    </button>
                  )}
                </div>
              )
            }
          </div>
        </div >
      </div>
    </div >
  );
};

export default RegistrarLead;
